
import { mapState } from 'vuex'
import subNav from '~/components/common/subNav.vue'
import noData from '~/components/common/noData.vue'
import homeDown from '~/components/home/homeDown.vue'
import userinfo from '~/components/employee/userinfo.vue'
import relativeBrand from '~/components/employee/relativeBrand.vue'
import basicInfo from '~/components/employee/basicInfo.vue'
import company from '~/components/employee/company.vue'
import otherEmployee from '~/components/employee/otherEmployee.vue'
import Hide from '@/components/dealer/hide.vue'
export default {
  name: 'NewsList',
  components: {
    Hide,
    'sub-nav': subNav,
    'no-data': noData,
    'home-down': homeDown,
    userinfo,
    'relative-brand': relativeBrand,
    'basic-info': basicInfo,
    company,
    'other-employee': otherEmployee
  },
  provide() {
    return {
      detail: this.detail,
      hotEmployee: this.hotEmployee,
      downurl: this.downurl
    }
  },
  asyncData({ redirect, $api, app, store, route, res, $cookies, $serverlog, error, $getBrokerDomain }) {
    try {
      const workerId = route.params.id && route.params.id.split('.')[0]
      const dealerCode = route.query.dealerCode

      const worker = $api.common
        .V3(
          {
            officerId: workerId
          },
          { Routes: 'wikifxagg$company_officerdetail' }
        )
        .catch(() => {})

      // 下载链接
      const wikidatadownload = $api.download.init().catch(() => {
        console.log('wikidatadownload')
      })

      // 热门懂事/高管
      const hotEmployeeList = $api.common.V3({}, { Routes: 'wikifxagg$company_officerdetail' }).catch(() => {})

      // 高管页面来源的交易商信息
      let dealerTask = null
      if (dealerCode) {
        dealerTask = $api.dealer
          .gettraderbycodesForServer({
            codes: dealerCode
          })
          .catch(() => {})
      }

      return Promise.all([worker, wikidatadownload, hotEmployeeList, dealerTask])
        .then((ret) => {
          const _detail = ret[0]?.wikifxagg?.company_officerdetail?.data
          if (!_detail?.officerId) {
            res.statusCode = 404
            return { dataShow: false }
          }

          const navData = [
            {
              link: '/',
              text: '20641',
              type: 'a'
            }
          ]

          const _DealerInfo = (ret[3] && ret[3][0]) || {}
          const dealerName = _DealerInfo?.localShortName && _DealerInfo?.englishShortName && _DealerInfo?.localShortName != _DealerInfo?.englishShortName ? _DealerInfo?.englishShortName + '  ' + _DealerInfo?.localShortName : _DealerInfo?.localShortName || _DealerInfo?.englishShortName

          if (_DealerInfo?.code) {
            navData.push({
              link: `/dealer/${_DealerInfo?.code}.html`,
              text: dealerName,
              type: 'a',
              translation: true
            })
          } else if (_detail?.companyInfo?.companyId) {
            navData.push({
              link: `/company/${_detail?.companyInfo?.companyId}.html`,
              text: _detail?.companyInfo?.fullName,
              type: 'a',
              isBroker: true,
              translation: true
            })
          }

          navData.push({
            link: '#',
            text: _detail?.briefInfo?.name,
            type: 'span',
            translation: true
          })

          // console.log('_detail', _detail)
          return {
            workerId,
            detail: _detail || {},
            nav_data: navData, // 面包屑导航
            downurl: ret[1] ? ret[1] : [],
            DealerInfo: _DealerInfo
          }
        })
        .catch((err) => {
          return { err }
        })
    } catch (err) {
      $serverlog(error(err).message)
    }
  },
  data() {
    return {
      dataShow: true,
      detail: {},
      nav_data: [],
      downurl: [],
      DealerInfo: {}
    }
  },
  head() {
    const name = this.detail?.briefInfo?.name || ''
    const cpname = this.detail?.companyInfo?.fullName || ''
    const zhuangtai = this.detail?.basicInfo?.officerStatus || ''
    const position = this.detail?.basicInfo?.positionName?.join(',') || ''
    const _title = this.$t('55984').replace(/\{0}/g, name).replace(/\{1}/g, cpname).replace(/\{2}/g, zhuangtai).replace(/\{3}/g, position)
    const _des = this.$t('55985').replace(/\{0}/g, name).replace(/\{1}/g, cpname).replace(/\{2}/g, zhuangtai).replace(/\{3}/g, position)
    return {
      title: _title,
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: _des
        }
      ],
      script: [
        {
          type: 'application/ld+json',
          json: this.googlenav(this.nav_data)
        }
      ]
    }
  },
  computed: {
    ...mapState({
      isMobile: 'mobile'
    })
  },
  mounted() {
    this.$refs.hideref.open(this.workerId, 3, () => {})
    console.log('detail', this.detail)
    console.log('DealerInfo', this.DealerInfo)
    window.addEventListener('resize', this.$forceUpdate()) // 监听视图大小变化
  },
  methods: {
    get_search() {
      this.$refs.articleSearch.open()
    },
    onCopy(url) {
      const input = document.createElement('input')
      document.body.appendChild(input)
      input.setAttribute('value', url)
      input.select()
      document.execCommand('Copy')
      this.$message({
        message: this.$t('22208'),
        type: 'success'
      })
      document.body.removeChild(input)
    }
  }
}
